module.exports = __webpack_public_path__ + "c31fc6325122fa171735a5c3e389aaba.png";